import {
  StackLayout,
  Card,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useIntl } from '@leagueplatform/locales';
import { ReactNode } from 'react';
import { SECONDARY_CONTENT_MAX_WIDTH } from 'common/constants';
import { PageHeader } from 'components/page-header/page-header.component';
import { PageContentWrapper } from 'components/page-content-wrapper.component';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';
import { AmplarContactUsContent } from './contact-us-content.amplar.component';
import { MyHealthContactUsContent } from './contact-us-content.my-health.component';

const ContactUsContentWrapper = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  const content = (
    <StackLayout
      orientation="vertical"
      spacing="$two"
      css={{ '.GDS-paragraph-text': { marginBlockEnd: 0 } }}
    >
      {children}
    </StackLayout>
  );

  if (isMobile) {
    return content;
  }

  return (
    <Card.Elevated backgroundColor="secondary">
      <Card.Section padding="$two">{content}</Card.Section>
    </Card.Elevated>
  );
};

export const ContactUs = () => {
  const { formatMessage } = useIntl();
  const { systemId } = usePatientPortalContext();

  useDocumentTitle(formatMessage({ id: 'STR_CONTACT_US' }));

  return (
    <PageContentWrapper css={{ maxWidth: SECONDARY_CONTENT_MAX_WIDTH }}>
      <PageHeader headingId="STR_CONTACT_US" showBackButton={false} />
      <ContactUsContentWrapper>
        {systemId === PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH ? (
          <MyHealthContactUsContent />
        ) : (
          <AmplarContactUsContent />
        )}
      </ContactUsContentWrapper>
    </PageContentWrapper>
  );
};
